<template>
  <div
    class="
      doorder_forget_password doorder-auth-container doorder-auth-bg-container
    "
  >
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <ForgetPassword
            welcomeHeader="Reset password"
            welcomeSubheader="Please enter your registered email to send you a link to reset your password "
            logoSrc="doorder/Logo.png"
            guard="DOORDER"
            clientLink="doorder"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgetPassword from "@/components/auth/ForgetPassword.vue";

export default {
  name: "DoorderForgetPassword",
  components: { ForgetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit forget password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doorder-styles.css";
@import "../css/doorder-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doorder/auth/ForgetPasswordView.vue